import InvestCloseForm from './InvestCloseFormNew';

export default InvestCloseForm;
